export const removeEmailsFromUserOptions = (userOption) => {
  if (!Array.isArray(userOption)) {
    throw new TypeError("Expected an array of user options");
  }

  return userOption.map((option) => {
    if (typeof option.label !== "string") {
      throw new TypeError("Each option must have a string `label` field");
    }

    const emailRegex = /\s\([^)]*\)$/;
    const newLabel = option.label.replace(emailRegex, "").trim();

    return {
      ...option,
      label: newLabel,
    };
  });
};

export const filterUserOptions = (userOption, boardUsers, currentUser) => {
  const updatedOptions = removeEmailsFromUserOptions(userOption);
  return updatedOptions.filter(
    (item) =>
      !boardUsers?.some((el) => el.user_id === item.value) ||
      currentUser?.user_id === item.value
  );
}; 